'use client';

import { createFormControl } from 'react-hook-form';

import { FormFields } from './formTypes';

/**
 * Shared form control instance for the purchase form.
 * Allows multiple components to access the same form state.
 *
 * Ref: https://react-hook-form.com/docs/createFormControl
 */
export const purchaseFormCtx = createFormControl<FormFields>();
